import styled from 'styled-components';

const FilterLabel = styled.span`
  font-size: 14px;
  margin-bottom: 4px;
`;

export default FilterLabel;
